import { LinkTo } from '@ember/routing';
import { hash } from '@ember/helper';
import { service } from '@ember/service';
import { t } from 'ember-intl';
import Component from '@glimmer/component';
import Tile from '../tile';
import { PhWarning, PhPlus } from 'ember-phosphor-icons';
import Button from 'tio-ui/components/button';
import type EmployeeService from 'tio-employee/services/employee';
import type PartnerService from 'tio-employee/services/partner';
import type SessionContextService from 'tio-employee/services/session-context';
import type UploadProviderLogicService from 'tio-employee/services/upload-provider-logic';

interface DashboardAddLoanSignature {
  Args: {};
}
export default class DashboardAddLoan extends Component<DashboardAddLoanSignature> {
  @service declare employee: EmployeeService;
  @service declare partner: PartnerService;
  @service declare sessionContext: SessionContextService;
  @service declare uploadProviderLogic: UploadProviderLogicService;

  get person() {
    return this.sessionContext.user?.person;
  }

  get isSlr() {
    return (
      this.person?.employees?.some((employee) => {
        return employee.isActive && !!employee.plan && employee.plan.cadence !== 'NEVER';
      }) ?? false
    );
  }

  get hasSyf() {
    return !!this.partner.isSyfEnabled;
  }

  get hasPslf() {
    return !!this.partner.isPslfEnabled && !!this.partner.isPslfEligible;
  }

  get isWellnessOnly() {
    return (
      (this.person?.employees?.some((employee) => {
        return employee.isActive && !!employee.plan && employee.plan.cadence === 'NEVER';
      }) ??
        false) &&
      !this.isSlr
    );
  }

  get uploadQueryParams() {
    return this.uploadProviderLogic.getUploadParams({
      isSlr: this.isSlr,
      hasSyf: this.hasSyf,
      hasPslf: this.hasPslf,
      isWellnessOnly: this.isWellnessOnly,
    });
  }

  <template>
    <LinkTo
      @route="authenticated.observability.upload"
      @query={{hash
        source=this.uploadQueryParams.source
        providers=this.uploadQueryParams.providers
      }}
    >
      <Tile @headerText={{t "dashboard_tiles.add_student_loans"}} @isUrgent={{true}}>
        <:body>
          <div class="tio-place-center grow">
            <div class="flex flex-row items-center mb-4">
              <PhWarning @size="48" @weight="fill" class="m-3 tio-fg-danger" />
              <span class="ml-2">{{t "dashboard_tiles.link_accounts"}}</span>
            </div>
            <div class="flex flex-row items-center mb-4">
              <Button
                @intent="primary"
                @appearance="outlined"
                @icon={{PhPlus}}
                @label={{t "dashboard_tiles.add_loans"}}
              />
            </div>
          </div>
        </:body>
      </Tile>
    </LinkTo>
  </template>
}
